<mat-form-field
    subscriptSizing="dynamic"
    class="st-date-time-range"
    [matTooltip]="label()">
    <mat-label *ngIf="label()">{{ label() }}</mat-label>
    <mat-date-range-input
        [formGroup]="range"
        [disabled]="disabled()"
        [rangePicker]="picker">
        <input
            matStartDate
            formControlName="from"
            [placeholder]="startDateLabel()"
            (dateChange)="dateChange()" />
        <input
            matEndDate
            formControlName="to"
            [placeholder]="endDateLabel()"
            (dateChange)="dateChange()" />
    </mat-date-range-input>
    <mat-datepicker-toggle
        matIconSuffix
        [for]="picker" />
    <mat-date-range-picker
        #picker
        panelClass="st-date-time-picker-calendar"
        (closed)="closed()">
        <mat-date-range-picker-actions>
            <button
                mat-button
                matDatepickerCancel
                (click)="clearDate()">
                {{ clearLabel() }}
            </button>
            <button
                mat-button
                class="st-date-time-range-apply"
                matDatepickerApply>
                {{ applyLabel() }}
            </button>
        </mat-date-range-picker-actions>
    </mat-date-range-picker>
    <ng-container
        *ngIf="hasSuffix()"
        matSuffix>
        <ng-content select="[suffix]" />
    </ng-container>
    <ng-container
        *ngIf="hasPrefix()"
        matPrefix>
        <ng-content select="[prefix]" />
    </ng-container>
    <ng-container
        *ngIf="hasError()"
        matError>
        <ng-content select="[error]" />
    </ng-container>
</mat-form-field>
